import React from 'react';

import { ComponentsRead } from 'src/modules/card/kardComponents/items';
import Gallery from 'src/modules/card/kardComponents/CategoryGalleryInline';

export default
  <>
    <Gallery components={() => <ComponentsRead />} />
  </>;
